import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState({
    isMobile: window.innerWidth < MOBILE_BREAKPOINT,
    isTablet:
      window.innerWidth > MOBILE_BREAKPOINT &&
      window.innerWidth <= TABLET_BREAKPOINT,
    isLaptop: window.innerWidth > TABLET_BREAKPOINT,
  });

  useEffect(() => {
    const handleResize = () => {
      setDeviceType({
        isMobile: window.innerWidth < MOBILE_BREAKPOINT,
        isTablet:
          window.innerWidth > MOBILE_BREAKPOINT &&
          window.innerWidth <= TABLET_BREAKPOINT,
        isLaptop: window.innerWidth > TABLET_BREAKPOINT,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
};

export default useDeviceType;
